module.exports = __webpack_public_path__ + "img/star2.f81f7aff.png";